export const errorMessage = {
  SUCCESS: 'Успешно:',
  INFO: 'Информация:',
  WARNING: 'Предупреждение:',
  ERROR: 'Ошибка:'
} as const

export const errorDescription = {
  INSUFFICIENT_PERMISSIONS: 'Недостаточно прав для использования приложения',
  DEFAULT: 'Что то пошло не так. Попробуйте повторить позже'
} as const
